import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container } from "./styles";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { AiOutlineShoppingCart } from "react-icons/ai";

import { useSelector, useDispatch } from "react-redux";
import { totalItens, getCart } from "../../Redux/cartSlice";

import { useOpen } from "../../hooks/Open";
import { useUserData } from "../../hooks/UserContext";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -3,
    top: -9,
    backgroundColor: "rgba(78, 255, 62, 1)",
    color: "#000000",
  },
}));

function CarBuy() {
  const { openCart } = useOpen();
  const location = useLocation();
  const total = useSelector(totalItens);
  const dispatch = useDispatch();
  const { user, addressShipping, haveAddressShippingRequest } = useUserData();
  const screenName = useScreenTracking();

  const handleCartClick = () => {
    trackClick({
      title: "abrir-carrinho",
      contentType: "header",
      screenName,
      tagId: tagIdFromLegacySuffix("01"),
    });
    openCart();
  };

  useEffect(() => {
    const uuid = user.uuid;
    const cep = addressShipping?.cep ?? user.addresses?.[0]?.cep;
    if (uuid && (cep || haveAddressShippingRequest)) {
      dispatch(getCart({ uuid, cep, force: true }));
    }
  }, [
    user,
    addressShipping,
    haveAddressShippingRequest,
    location.pathname,
    dispatch,
  ]);

  return (
    <Container>
      <IconButton
        aria-label="cart"
        onClick={handleCartClick}
        sx={{
          minWidth: "44px",
          minHeight: "44px",
          width: "44px",
          height: "44px",
          "& svg": {
            color: "white!important",
          },
        }}
      >
        <StyledBadge badgeContent={total} />
        <AiOutlineShoppingCart style={{ fontSize: "24px" }} />
      </IconButton>
    </Container>
  );
}

export default CarBuy;
